import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import createMarkup from 'helpers/createMarkup';
import Avatar from 'components/common/Avatar';

const Notification = ({
  avatar,
  time,
  className,
  unread,
  flush,
  emoji,
  children,
  to
}) => {
  // Determine badge size based on ticket number length (if available)
  let badgeSize = '1.2em';
  let badgeFontSize = '0.85em';
  if (children) {
    // Try to extract ticket number from children string
    const match = String(children).match(/<strong>(\d+)<\/strong>/);
    if (match && match[1]) {
      const len = match[1].length;
      if (len >= 4) {
        badgeSize = '1.7em';
        badgeFontSize = '1em';
      } else if (len === 3) {
        badgeSize = '1.4em';
        badgeFontSize = '0.95em';
      }
    }
  }
  return (
    <Link
      className={classNames(
        'notification',
        { 'notification-unread': unread, 'notification-flush': flush },
        className
      )}
      to={to}
    >
      {avatar && (
        <div className="notification-avatar" style={{ position: 'relative' }}>
          <Avatar {...avatar} className="me-3" />
          {/* Notification badge/circle */}
          {children && (
            <span
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                background: '#ff5252',
                color: '#fff',
                borderRadius: '50%',
                minWidth: badgeSize,
                minHeight: badgeSize,
                fontSize: badgeFontSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                zIndex: 2,
                padding: '0 0.3em',
                boxShadow: '0 0 0 2px #fff',
                lineHeight: 1,
                textAlign: 'center',
                height: badgeSize,
                width: 'auto',
                left: 'auto',
                transform: 'translate(30%,-30%)'
              }}
            >
              {/* Show ticket number if available */}
              <span
                style={{
                  width: '100%',
                  textAlign: 'center',
                  display: 'block'
                }}
              >
                {(() => {
                  const match = String(children).match(/<strong>(\d+)<\/strong>/);
                  return match && match[1] ? match[1] : '';
                })()}
              </span>
            </span>
          )}
        </div>
      )}
      <div className="notification-body">
        <p className="mb-1" dangerouslySetInnerHTML={createMarkup(children)} />
        <span className="notification-time">
          {emoji && (
            <span className="me-2" role="img" aria-label="Emoji">
              {emoji}
            </span>
          )}
          {time}
        </span>
      </div>
    </Link>
  );
};

Notification.propTypes = {
  avatar: PropTypes.shape(Avatar.propTypes),
  time: PropTypes.string.isRequired,
  className: PropTypes.string,
  unread: PropTypes.bool,
  flush: PropTypes.bool,
  emoji: PropTypes.string,
  children: PropTypes.node
};

Notification.defaultProps = { unread: false, flush: false };

export default Notification;
